import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import { MdDeleteOutline, MdEditSquare } from "react-icons/md";
// import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { IoAdd, IoInformationCircleSharp } from 'react-icons/io5';
import { IoMdClose } from 'react-icons/io';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { BeatLoader } from 'react-spinners';
import { Toaster } from 'react-hot-toast';

const initialVisualizerData = {
    id: 2,
    name: "DC-Kitchen-Visualizer 2",
    key: "h3negal0",
    user_id: 1,
    visualizertype_id: 1,
    info: "",
    contact_person_name: "John Snow",
    contact_person_email: "johnsnow@gmail.com",
    status: true,
    created_at: null,
    updated_at: "2025-05-13T11:05:02.000Z",
    VisualizerAngles: [],
    VisualizerCategory: [
        { id: 9, visualizer_id: 2, category_id: 1, order: 1, status: true, created_at: "2024-12-07T11:35:37.000Z", updated_at: "2024-12-07T11:35:37.000Z" },
        { id: 10, visualizer_id: 2, category_id: 2, order: 2, status: true, created_at: "2024-12-07T11:37:11.000Z", updated_at: "2024-12-07T11:37:11.000Z" },
        { id: 11, visualizer_id: 2, category_id: 3, order: 3, status: true, created_at: "2024-12-07T11:37:11.000Z", updated_at: "2024-12-07T11:37:11.000Z" },
        { id: 12, visualizer_id: 2, category_id: 4, order: 4, status: true, created_at: "2024-12-07T11:37:11.000Z", updated_at: "2024-12-07T11:37:11.000Z" },
        { id: 16, visualizer_id: 2, category_id: 5, order: 5, status: true, created_at: "2024-12-07T11:37:11.000Z", updated_at: "2024-12-07T11:37:11.000Z" },
        { id: 17, visualizer_id: 2, category_id: 6, order: 6, status: true, created_at: "2024-12-07T11:37:11.000Z", updated_at: "2024-12-07T11:37:11.000Z" },
        { id: 18, visualizer_id: 2, category_id: 7, order: 7, status: true, created_at: "2024-12-07T11:37:11.000Z", updated_at: "2024-12-07T11:37:11.000Z" },
        { id: 19, visualizer_id: 2, category_id: 8, order: 8, status: true, created_at: "2024-12-07T11:37:11.000Z", updated_at: "2024-12-07T11:37:11.000Z" },
    ],
};

const initialTableData = {
    1: [
        { colorName: "Matte Black", image1: "img1.jpg", image2: "img2.jpg", status: true, haveGrain: true },
        { colorName: "Glossy White", image1: "img3.jpg", image2: "img4.jpg", status: false, haveGrain: false },
    ],
    2: [
        { colorName: "Oak Brown", image1: "img5.jpg", image2: "img6.jpg", status: true, haveGrain: true },
        { colorName: "Slate Gray", image1: "img7.jpg", image2: "img8.jpg", status: true, haveGrain: false },
    ],
};

const DetailsAgain = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const visualizer = location.state?.visualizer || initialVisualizerData;

    const [selectedAngle, setSelectedAngle] = useState("1");
    const [activeTab, setActiveTab] = useState(visualizer.VisualizerCategory[0]?.category_id || 1);
    const [popup, setPopup] = useState(false);
    const [addColorPopup, setAddColorPopup] = useState(false);
    const [manageCategoriesPopup, setManageCategoriesPopup] = useState(false);
    const [categories, setCategories] = useState(visualizer.VisualizerCategory);
    const [tempCategories, setTempCategories] = useState([]);
    const [categoryNames, setCategoryNames] = useState({
        1: "Base Cabinets",
        2: "Island Cabinets",
        3: "Wall Cabinets",
        4: "Tall Cabinets",
        5: "Flooring",
        6: "Appliances",
        7: "Backslash",
        8: "Countertop",
    });
    const [newCategoryName, setNewCategoryName] = useState("");
    const [tableData, setTableData] = useState(initialTableData);
    const [newColor, setNewColor] = useState({
        name: '',
        visualizer_category_id: '',
        is_default: 'false',
        have_grain: 'false',
        image: null,
        assets_color_thumbnail: null,
        vertical_grain_image: null,
        horizontal_grain_image: null,
        vertical_sequence_grain_image: null,
        horizontal_sequence_grain_image: null,
        status: 'true',
    });

    const [formData, setFormData] = useState({
        id: "",
        name: "",
        visualizer_id: "",
        visualizer_category_id: "",
        visualizer_style_type_id: "",
        assets_color_thumbnail: "",
        image: "",
        haveGrain: "0",
        vertical_grain_image: "",
        horizontal_grain_image: "",
        vertical_sequence_grain_image: "",
        horizontal_sequence_image: "",
        isDefault: "0",
        status: "1",
    });

    const [errors, setErrors] = useState({});
    const [selectedCategoryId, setSelectedCategoryId] = useState('');

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        const { name } = e.target;
        if (file) {
            if (file.type === "image/svg+xml") {
                setFormData((prevData) => ({
                    ...prevData,
                    [name]: file,
                }));
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: "",
                }));
            } else {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: "Please upload an SVG image",
                }));
            }
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSubCategory = (e) => {
        const selectedCategoryId = e.target.value;
        setSelectedCategoryId(selectedCategoryId);
    };

    const handleSubmitColorData = () => {
        // Handle form submission logic here
        setAddColorPopup(false);
    };

    const handleAngleChange = (e) => {
        setSelectedAngle(e.target.value);
    };

    const handleTabClick = (categoryId) => {
        setActiveTab(categoryId);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewColor((prev) => ({
            ...prev,
            [name]: name === "status" || name === "haveGrain" ? value === "true" : value,
        }));
    };

    const handleAddColor = () => {
        if (!newColor.colorName.trim()) {
            // setError("Color Name is required");
            return;
        }

        setTableData((prev) => ({
            ...prev,
            [selectedAngle]: [
                ...(prev[selectedAngle] || []),
                {
                    colorName: newColor.colorName,
                    image1: newColor.image1 || null,
                    image2: newColor.image2 || null,
                    status: newColor.status,
                    haveGrain: newColor.haveGrain,
                },
            ],
        }));

        setNewColor({
            colorName: "",
            image1: "",
            image2: "",
            status: true,
            haveGrain: true,
        });
        // setError("");
        setAddColorPopup(false);
    };

    const handleDragEnd = (result) => {
        if (!result.destination) return;

        const reorderedCategories = Array.from(categories);
        const [movedCategory] = reorderedCategories.splice(result.source.index, 1);
        reorderedCategories.splice(result.destination.index, 0, movedCategory);

        // Update the order property
        const updatedCategories = reorderedCategories.map((category, index) => ({
            ...category,
            order: index + 1,
        }));

        setCategories(updatedCategories);

        // Update activeTab if the currently active tab was moved
        const movedCategoryId = movedCategory.category_id;
        if (activeTab === movedCategoryId) {
            setActiveTab(movedCategoryId); // Keep the same tab active
        }
    };

    const handleOpenManageCategories = () => {
        setTempCategories([...categories]); // Copy current categories to temp state
        setManageCategoriesPopup(true);
    };

    const handleAddCategory = () => {
        if (!newCategoryName.trim()) return;

        const newCategoryId = Math.max(...tempCategories.map(c => c.category_id), 0) + 1;
        const newOrder = tempCategories.length + 1;

        const newCategory = {
            id: newCategoryId + 100, // Temporary ID for demo
            visualizer_id: 2,
            category_id: newCategoryId,
            order: newOrder,
            status: true,
            created_at: new Date().toISOString(),
            updated_at: new Date().toISOString(),
        };

        setTempCategories([...tempCategories, newCategory]);
        setNewCategoryName("");
    };

    const handleRemoveCategory = (categoryId) => {
        const updatedTempCategories = tempCategories.filter(category => category.category_id !== categoryId);
        // Reassign order values
        const reorderedCategories = updatedTempCategories.map((category, index) => ({
            ...category,
            order: index + 1,
        }));
        setTempCategories(reorderedCategories);
    };

    const handleSaveCategories = () => {
        setCategories([...tempCategories]);

        // Update categoryNames with new categories
        const newCategoryId = Math.max(...tempCategories.map(c => c.category_id), 0);
        if (newCategoryName && tempCategories.some(cat => cat.category_id === newCategoryId)) {
            setCategoryNames((prev) => ({
                ...prev,
                [newCategoryId]: newCategoryName,
            }));
        }
        setCategories([...tempCategories]); // this triggers tab update

        setManageCategoriesPopup(false);
        setNewCategoryName("");
    };

    const InputField = ({ label, name, value, onChange }) => (
        <div className="relative z-0 w-full mb-1 group">
            <input
                type="text"
                name={name}
                value={value}
                onChange={onChange}
                className="block py-2.5 px-2 w-full text-sm text-gray-900 border-b bg-transparent appearance-none focus:outline-none peer"
                placeholder=" "
            />
            <label className="absolute text-xs md:text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:text-teal-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
                {label}
            </label>
        </div>
    );

    const SelectField = ({ label, name, value, onChange }) => (
        <div className="relative z-0 w-full mb-1 group">
            <select
                name={name}
                value={value}
                onChange={onChange}
                className="block py-2.5 px-2 w-full text-sm text-gray-900 border-b bg-transparent appearance-none focus:outline-none peer"
            >
                <option value="true">True</option>
                <option value="false">False</option>
            </select>
            <label className="absolute text-xs md:text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:text-teal-500">
                {label}
            </label>
        </div>
    );

    const FileField = ({ label, name, onChange }) => (
        <div className="relative z-0 w-full mb-1 group">
            <input
                type="file"
                name={name}
                accept="image/*"
                onChange={onChange}
                className="block py-2.5 px-2 w-full text-sm text-gray-900 bg-transparent border-b appearance-none focus:outline-none"
            />
            <label className="text-xs md:text-sm text-gray-500">{label}</label>
        </div>
    );

    const handleDragEndInPopup = (result) => {
        if (!result.destination) return;

        const reordered = Array.from(tempCategories);
        const [moved] = reordered.splice(result.source.index, 1);
        reordered.splice(result.destination.index, 0, moved);

        // ✅ THIS is the key part
        const updatedWithOrder = reordered.map((cat, index) => ({
            ...cat,
            order: index + 1,
        }));

        setTempCategories(updatedWithOrder);
    };




    return (
        <>
            {/* {loading && (
                <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-black/30">
                    <BeatLoader
                        // color="yellow"
                        // loading={true}
                        size={20}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                    />
                </div>
            )} */}
            <Toaster position="top-center" />
            <div className="flex h-screen fixed w-full">
                <div className="md:w-64 w-16 bg-black transition-all">
                    <Sidebar />
                </div>
                <div className="flex flex-col flex-1 min-h-full">
                    <div className="bg-gray-100 flex-1 p-4 overflow-auto min-h-full">
                        <div className="bg-white rounded-2xl w-full flex flex-col min-h-full">
                            {/* Header Section */}
                            <div className="flex justify-between items-center px-6 pt-4">
                                <div>
                                    <p className="text-teal-500 text-xl font-semibold flex items-center gap-3">
                                        Visualizer Details for Kitchen Visualizer 1
                                        <span>
                                            <IoInformationCircleSharp
                                                onClick={() => setPopup(true)}
                                                color='black'
                                                className='cursor-pointer'
                                            />
                                        </span>
                                    </p>
                                    <p className="text-gray-600 mb-4">
                                        <span className="text-teal-500">
                                            <Link to="/admin/layouts" className="hover:text-teal-600 transition">Visualizer</Link>
                                        </span>
                                        <span className="text-gray-500"> / Details</span>
                                    </p>
                                </div>
                                <button
                                    onClick={() => navigate('/admin/layouts')}
                                    className="bg-gradient-to-r from-teal-400 to-teal-500 text-white rounded px-4 py-2 hover:from-teal-500 hover:to-teal-600 transition shadow-md"
                                >
                                    Back
                                </button>
                            </div>
                            <hr className="border-gray-200" />

                            {/* Details Section */}
                            <div className="bg-white rounded-2xl w-full h-full px-4 flex-1 flex flex-col justify-between">
                                <div className="mb-4 flex-1">
                                    <div className="mx-auto text-xs md:text-base">
                                        {/* Angle Dropdown */}
                                        <div className="p-6">
                                            <p className="text-xl font-semibold text-teal-500 mb-4">Select Angle</p>
                                            <div className="relative z-0 w-full max-w-xs mb-1 group">
                                                <select
                                                    id="angle"
                                                    name="angle"
                                                    value={selectedAngle}
                                                    onChange={handleAngleChange}
                                                    className="block py-2.5 px-2 w-full text-sm text-gray-900 bg-transparent border rounded-lg border-gray-300 appearance-none focus:outline-none border-b peer"
                                                >
                                                    <option value="1">Angle 1</option>
                                                    <option value="2">Angle 2</option>
                                                </select>
                                            </div>
                                        </div>

                                        {/* Tabs for Categories */}
                                        <div className="p-6">
                                            <p className="text-xl font-semibold text-teal-500 mb-4">Visualizer Categories</p>
                                            <div className="flex justify-between items-center mb-4">
                                                <DragDropContext onDragEnd={handleDragEnd}>
                                                    <Droppable droppableId="categories" direction="horizontal">
                                                        {(provided) => (
                                                            <div
                                                                className="flex space-x-4"
                                                                {...provided.droppableProps}
                                                                ref={provided.innerRef}
                                                                style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}
                                                            >
                                                                {categories
                                                                    .sort((a, b) => a.order - b.order)
                                                                    .map((category, index) => (
                                                                        <Draggable
                                                                            key={category.category_id.toString()}
                                                                            draggableId={category.category_id.toString()}
                                                                            index={index}
                                                                        >
                                                                            {(provided, snapshot) => (
                                                                                <button
                                                                                    ref={provided.innerRef}
                                                                                    {...provided.draggableProps}
                                                                                    {...provided.dragHandleProps}
                                                                                    onClick={() => handleTabClick(category.category_id)}
                                                                                    className={`px-4 py-2 rounded-lg text-sm font-medium transition ${activeTab === category.category_id
                                                                                        ? 'bg-teal-500 text-white'
                                                                                        : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                                                                                        } ${snapshot.isDragging ? 'shadow-lg' : ''}`}
                                                                                >
                                                                                    {categoryNames[category.category_id] || `Category ${category.category_id}`}
                                                                                </button>
                                                                            )}
                                                                        </Draggable>
                                                                    ))}
                                                                {provided.placeholder}
                                                            </div>
                                                        )}
                                                    </Droppable>
                                                </DragDropContext>
                                                <button
                                                    onClick={handleOpenManageCategories}
                                                    className="bg-gradient-to-r from-teal-400 to-teal-500 text-white rounded-lg px-3 py-2 hover:from-teal-500 hover:to-teal-600 transition shadow-md"
                                                >
                                                    <IoAdd size={20} />
                                                </button>
                                            </div>

                                            {/* Add Color Button */}
                                            <div className="flex justify-end mb-4">
                                                <button
                                                    onClick={() => setAddColorPopup(true)}
                                                    className="bg-gradient-to-r from-teal-400 to-teal-500 text-white rounded-lg px-6 py-2 hover:from-teal-500 hover:to-teal-600 transition shadow-md"
                                                >
                                                    Add {categoryNames[activeTab]} Color
                                                </button>
                                            </div>

                                            {/* Table View */}
                                            <div className="overflow-x-auto">
                                                <table className="min-w-full border-collapse bg-white rounded-lg shadow-md">
                                                    <thead>
                                                        <tr className="bg-gray-100 text-gray-800">
                                                            <th className="text-start p-3 text-sm md:text-base font-medium"> Name</th>
                                                            <th className="text-start p-3 text-sm md:text-base font-medium">Thumbnail</th>
                                                            <th className="text-start p-3 text-sm md:text-base font-medium">Image</th>
                                                            <th className="text-start p-3 text-sm md:text-base font-medium">Status</th>
                                                            <th className="text-start p-3 text-sm md:text-base font-medium">Have Grain</th>
                                                            <th className="text-start p-3 text-sm md:text-base font-medium">Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {(tableData[selectedAngle] || []).map((item, index) => (
                                                            <tr key={index} className="border-b border-gray-200 hover:bg-gray-50 transition">
                                                                <td className="p-3 text-sm md:text-base text-gray-800">{item.colorName}</td>
                                                                <td className="p-3 text-sm md:text-base text-gray-800">
                                                                    {item.image1 ? (
                                                                        <span className="text-teal-500">Image 1</span>
                                                                    ) : "N/A"}
                                                                </td>
                                                                <td className="p-3 text-sm md:text-base text-gray-800">
                                                                    {item.image2 ? (
                                                                        <span className="text-teal-500">Image 2</span>
                                                                    ) : "N/A"}
                                                                </td>
                                                                <td className="p-3 text-sm md:text-base text-gray-800">
                                                                    {item.status ? "Active" : "Inactive"}
                                                                </td>
                                                                <td className="p-3 text-sm md:text-base text-gray-800">
                                                                    {item.haveGrain ? "Yes" : "No"}
                                                                </td>
                                                                <td className="p-3 flex gap-3 text-sm md:text-base text-gray-800">
                                                                    <MdEditSquare title='edit' className='cursor-pointer' size={20} />
                                                                    <MdDeleteOutline color='red' title='delete' className='cursor-pointer' size={20} />
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        {(tableData[selectedAngle] || []).length === 0 && (
                                                            <tr>
                                                                <td colSpan="6" className="text-gray-500 text-center p-4">
                                                                    No data available for this angle and category
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Visualizer Details Popup Modal */}
                {popup && (
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-center z-50">
                        <div className="relative bg-white rounded-2xl p-6 w-[50%] max-h-[80vh] overflow-y-auto shadow-lg">
                            {/* Modal Header */}
                            <div className="flex justify-between items-center mb-4">
                                <p className="text-teal-500 text-xl font-semibold">Visualizer Details</p>
                                <button
                                    onClick={() => setPopup(false)}
                                    className="bg-gradient-to-r from-teal-400 to-teal-500 text-white rounded px-4 py-2 hover:from-teal-500 hover:to-teal-600 transition shadow-md"
                                >
                                    Close
                                </button>
                            </div>
                            <hr className="border-gray-200 mb-4" />

                            {/* Modal Content */}
                            <div className="grid grid-cols-2 md:grid-cols-2 gap-6">
                                <div className="flex items-center space-x-2">
                                    <span className="text-gray-500 text-sm font-medium">ID:</span>
                                    <span className="text-gray-900 text-sm">{visualizer.id}</span>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <span className="text-gray-500 text-sm font-medium">Name:</span>
                                    <span className="text-gray-900 text-sm">{visualizer.name}</span>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <span className="text-gray-500 text-sm font-medium">key:</span>
                                    <span className="text-gray-900 text-sm">{visualizer.key}</span>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <span className="text-gray-500 text-sm font-medium">Status:</span>
                                    <span className="text-gray-900 text-sm">{visualizer.status === true ? '1' : '0'}</span>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <span className="text-gray-500 text-sm font-medium">conatact_name:</span>
                                    <span className="text-gray-900 text-sm">{visualizer.contact_person_name || "N/A"}</span>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <span className="text-gray-500 text-sm font-medium">contact_email:</span>
                                    <span className="text-gray-900 text-sm">{visualizer.contact_person_email || "N/A"}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Add Color Popup Modal */}
                {addColorPopup && (
                    <div className="fixed inset-0 flex justify-center items-center bg-gray-500 bg-opacity-75">
                        <div className="bg-white p-6 h-[90%] w-3/4 md:w-[70%] shadow-lg ">
                            <h2 className="text-2xl font-bold mb-6 text-center">
                                Add New Color
                            </h2>
                            <div className='h-[80%] p-2 overflow-auto'>

                                <div className="flex-1 ">
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        <div className="mb-6">
                                            <label htmlFor="name" className="block text-sm font-semibold mb-2 text-gray-700">Color Name<span className="text-red-500">*</span></label>
                                            <input
                                                type="text"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                className="block w-full py-3 px-4 text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300"
                                                placeholder="Enter Color Name"
                                            />
                                            {errors.name && <p className="text-red-500 text-xs italic mt-2">{errors.name}</p>}
                                        </div>

                                        <div className="mb-6">
                                            <label className="block text-sm font-semibold mb-2 text-gray-700">Status <span className="text-red-500">*</span></label>
                                            <div className="flex items-center space-x-6">
                                                <label className="flex items-center space-x-2">
                                                    <input
                                                        type="radio"
                                                        name="status"
                                                        // value={formData.status}
                                                        // checked={formData.status === "1"}
                                                        onChange={handleChange}
                                                        className="text-blue-600"
                                                    />
                                                    <span>Active</span>
                                                </label>
                                                <label className="flex items-center space-x-2">
                                                    <input
                                                        type="radio"
                                                        name="status"
                                                        // value={formData.status}
                                                        // checked={formData.status === "0"}
                                                        onChange={handleChange}
                                                        className="text-red-600"
                                                    />
                                                    <span>Inactive</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        <div className="mb-6">
                                            <label htmlFor="childCategory" className="block text-sm font-semibold mb-2 text-gray-700">
                                                SubCategory<span className="text-red-500">*</span>
                                            </label>
                                            <select
                                                id="childCategory"
                                                name="childCategory"
                                                value={selectedCategoryId}
                                                onChange={handleSubCategory}
                                                className="block w-full py-3 px-4 text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300"
                                                placeholder="Enter subcategory"
                                            >
                                                <option value="" disabled>Select a category</option>
                                                <option value="AGT" >AGT</option>
                                                <option value="Shinnoki" >Shinnoki</option>

                                            </select>
                                            {errors.name && <p className="text-red-500 text-xs italic mt-2">{errors.name}</p>}
                                        </div>
                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        <div className="mb-6">
                                            <label htmlFor="assets_color_thumbnail" className="block text-sm font-semibold mb-2 text-gray-700">
                                                Thumbnail: <span className="text-red-500">*</span>
                                            </label>
                                            {formData.assets_color_thumbnail && (
                                                <div className="mb-2 mt-4">
                                                    <img
                                                        src={formData.assets_color_thumbnail}
                                                        alt="thumbnail Preview"
                                                        className="w-28 h-auto max-h-48 object-contain mb-4"
                                                    />
                                                </div>
                                            )}
                                            <input
                                                type="file"
                                                name="assets_color_thumbnail"
                                                onChange={(e) => setFormData({ ...formData, assets_color_thumbnail: e.target.files[0] })}
                                                className="block w-full text-sm text-gray-900 bg-transparent border-2 border-gray-300 rounded-lg py-3 px-4 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300"
                                            />
                                            {errors.assets_color_thumbnail && <p className="text-red-500 text-xs italic mt-2">{errors.assets_color_thumbnail}</p>}
                                        </div>

                                        <div className="mb-6">
                                            <label className="block text-sm font-semibold mb-2 text-gray-700">Have Grain</label>
                                            <div className="flex items-center space-x-6">
                                                <label className="flex items-center space-x-2">
                                                    <input
                                                        type="radio"
                                                        name="haveGrain"
                                                        value="1"
                                                        checked={formData.haveGrain === '1'}
                                                        onChange={handleChange}
                                                        className="text-blue-600"
                                                    />
                                                    <span>Yes</span>
                                                </label>
                                                <label className="flex items-center space-x-2">
                                                    <input
                                                        type="radio"
                                                        name="haveGrain"
                                                        value="0"
                                                        checked={formData.haveGrain === '0'}
                                                        onChange={handleChange}
                                                        className="text-red-600"
                                                    />
                                                    <span>No</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div className="relative z-0 w-full mb-5 group">
                                        <div className="items-center">
                                            <label htmlFor="name" className="block text-sm font-semibold mb-2 text-gray-700">Default Image: <span className="text-red-500">*</span></label>
                                            <label className="mr-4">
                                                <input
                                                    type="checkbox"
                                                    name="isDefault"
                                                    checked={formData.isDefault === "1"}
                                                    onChange={(e) => handleChange({ target: { name: 'isDefault', value: e.target.checked ? "1" : "0" } })}
                                                    className="mr-2"
                                                />
                                                Make this color Image Default
                                            </label>
                                        </div>
                                        {errors.isDefault && <p className="text-red-500 text-xs italic">{errors.isDefault}</p>}
                                    </div>
                                </div> */}

                                    {formData.haveGrain === '0' && (
                                        <div className="grid grid-cols-2 md:grid-cols-2 gap-6">
                                            <div className="mb-6">
                                                <label htmlFor="image" className="block text-sm font-semibold mb-2 text-gray-700">Color Image: <span className="text-red-500">*</span></label>
                                                {formData.image && formData.image.type === "image/svg+xml" && (
                                                    <div className="mb-4 mt-8">
                                                        <object
                                                            type="image/svg+xml"
                                                            data={URL.createObjectURL(formData.image)}
                                                            alt="Image Preview"
                                                            className="w-28 h-auto max-h-48 object-contain mb-4"
                                                        >
                                                            Your browser does not support SVG.
                                                        </object>
                                                    </div>
                                                )}
                                                <input
                                                    type="file"
                                                    id="image"
                                                    name="image"
                                                    onChange={handleFileChange}
                                                    className={`block py-4 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer ${errors.hover_svgfile ? 'border-red-500' : 'border-gray-300'}`}
                                                    placeholder=" "
                                                />
                                                <p className='text-xs mt-2'>upload SVG only</p>
                                                {errors.image && <p className="text-red-500 text-xs italic mt-2">{errors.image}</p>}
                                            </div>
                                        </div>
                                    )}

                                    {formData.haveGrain === '1' && (
                                        <>
                                            <p className='text-lg font-semibold mb-2 text-gray-700 pt-4'>Grain Color Images:</p>
                                            <div className='shadow-md bg-gray-50'>
                                                <div className="px-4 py-3 rounded-lg">
                                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                                        <div className="mb-6">
                                                            <label className="text-sm font-semibold text-gray-700">Vertical Color Image: <span className="text-red-500">*</span></label>
                                                            {formData.vertical_grain_image && formData.vertical_grain_image.type === "image/svg+xml" && (
                                                                <div className="mb-4 mt-8">
                                                                    <object
                                                                        type="image/svg+xml"
                                                                        data={URL.createObjectURL(formData.vertical_grain_image)}
                                                                        alt="vertical_grain_image Preview"
                                                                        className="w-28 h-auto max-h-48 object-contain mb-4"
                                                                    >
                                                                        Your browser does not support SVG.
                                                                    </object>
                                                                </div>
                                                            )}
                                                            <input
                                                                type="file"
                                                                name="vertical_grain_image"
                                                                onChange={handleFileChange}
                                                                className={`block py-4 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer ${errors.hover_svgfile ? 'border-red-500' : 'border-gray-300'}`}
                                                                placeholder=" "
                                                            />
                                                            <p className='text-xs mt-2'>upload SVG only</p>
                                                            {errors.vertical_grain_image && <p className="text-red-500 text-xs italic mt-2">{errors.vertical_grain_image}</p>}
                                                        </div>
                                                        <div className="mb-6">
                                                            <label className="text-sm font-semibold text-gray-700">Horizontal Color Image: <span className="text-red-500">*</span></label>
                                                            {formData.horizontal_grain_image && formData.horizontal_grain_image.type === "image/svg+xml" && (
                                                                <div className="mb-4 mt-8">
                                                                    <object
                                                                        type="image/svg+xml"
                                                                        data={URL.createObjectURL(formData.horizontal_grain_image)}
                                                                        alt="horizontal_grain_image Preview"
                                                                        className="w-28 h-auto max-h-48 object-contain mb-4"
                                                                    >
                                                                        Your browser does not support SVG.
                                                                    </object>
                                                                </div>
                                                            )}
                                                            <input
                                                                type="file"
                                                                name="horizontal_grain_image"
                                                                onChange={handleFileChange}
                                                                className={`block py-4 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer ${errors.hover_svgfile ? 'border-red-500' : 'border-gray-300'}`}
                                                                placeholder=" "
                                                            />
                                                            <p className='text-xs mt-2'>upload SVG only</p>
                                                            {errors.horizontal_grain_image && <p className="text-red-500 text-xs italic mt-2">{errors.horizontal_grain_image}</p>}
                                                        </div>
                                                    </div>

                                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                                        <div className="mb-6">
                                                            <label className="text-sm font-semibold text-gray-700">Vertical Seq. Color Image: <span className="text-red-500">*</span></label>
                                                            {formData.vertical_sequence_grain_image && formData.vertical_sequence_grain_image.type === "image/svg+xml" && (
                                                                <div className="mb-4 mt-8">
                                                                    <object
                                                                        type="image/svg+xml"
                                                                        data={URL.createObjectURL(formData.vertical_sequence_grain_image)}
                                                                        alt="vertical_sequence_grain_image Preview"
                                                                        className="w-28 h-auto max-h-48 object-contain mb-4"
                                                                    >
                                                                        Your browser does not support SVG.
                                                                    </object>
                                                                </div>
                                                            )}
                                                            <input
                                                                type="file"
                                                                name="vertical_sequence_grain_image"
                                                                onChange={handleFileChange}
                                                                className={`block py-4 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer ${errors.hover_svgfile ? 'border-red-500' : 'border-gray-300'}`}
                                                                placeholder=" "
                                                            />
                                                            <p className='text-xs mt-2'>upload SVG only</p>
                                                            {errors.vertical_sequence_grain_image && <p className="text-red-500 text-xs italic mt-2">{errors.vertical_sequence_grain_image}</p>}
                                                        </div>
                                                        <div className="mb-6">
                                                            <label className="text-sm font-semibold text-gray-700">Horizontal Seq. Color Image: <span className="text-red-500">*</span></label>
                                                            {formData.horizontal_sequence_image && formData.horizontal_sequence_image.type === "image/svg+xml" && (
                                                                <div className="mb-4 mt-8">
                                                                    <object
                                                                        type="image/svg+xml"
                                                                        data={URL.createObjectURL(formData.horizontal_sequence_image)}
                                                                        alt="horizontal_sequence_image Preview"
                                                                        className="w-28 h-auto max-h-48 object-contain mb-4"
                                                                    >
                                                                        Your browser does not support SVG.
                                                                    </object>
                                                                </div>
                                                            )}
                                                            <input
                                                                type="file"
                                                                name="horizontal_sequence_image"
                                                                onChange={handleFileChange}
                                                                className={`block py-4 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer`}
                                                            />
                                                            <p className='text-xs mt-2'>upload SVG only</p>
                                                            {errors.horizontal_sequence_image && <p className="text-red-500 text-xs italic mt-2">{errors.horizontal_sequence_image}</p>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>

                            <div className="flex justify-end gap-4 mt-6">
                                <button
                                    onClick={() => setAddColorPopup(false)}
                                    className="p-2 bg-red-500 text-white rounded hover:bg-red-700"
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleSubmitColorData}
                                    className="p-2 bg-green-500 text-white rounded hover:bg-green-700"
                                >
                                    Save and Compile
                                </button>
                            </div>

                        </div>
                    </div>
                )}

                {/* Manage Categories Popup Modal */}
                {manageCategoriesPopup && (
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-center z-50">
                        <div className="relative bg-white rounded-2xl p-6 w-[50%] max-h-[80vh] overflow-y-auto shadow-lg">
                            {/* Modal Header */}
                            <div className="flex justify-between items-center mb-4">
                                <p className="text-teal-500 text-xl font-semibold">Rearrange Categories</p>
                                <button
                                    onClick={() => setManageCategoriesPopup(false)}
                                    className="bg-gradient-to-r from-teal-400 to-teal-500 text-white rounded px-4 py-2 hover:from-teal-500 hover:to-teal-600 transition shadow-md"
                                >
                                    Close
                                </button>
                            </div>
                            <hr className="border-gray-200 mb-4" />

                            {/* Modal Content */}
                            <div className="space-y-4">
                                {/* List of Categories */}
                                <DragDropContext onDragEnd={handleDragEndInPopup}>
                                    <Droppable droppableId="popup-categories">
                                        {(provided) => (
                                            <div
                                                {...provided.droppableProps}
                                                ref={provided.innerRef}
                                                className="space-y-4"
                                            >
                                                {tempCategories
                                                    .sort((a, b) => a.order - b.order)
                                                    .map((category, index) => (
                                                        <Draggable
                                                            key={category.category_id.toString()}
                                                            draggableId={category.category_id.toString()}
                                                            index={index}
                                                        >
                                                            {(provided) => (
                                                                <div
                                                                    ref={provided.innerRef}
                                                                    {...provided.draggableProps}
                                                                    {...provided.dragHandleProps}
                                                                    className="flex justify-between items-center p-2 bg-gray-100 rounded-lg"
                                                                >
                                                                    <span className="text-gray-800">
                                                                        {categoryNames[category.category_id] || `Category ${category.category_id}`}
                                                                    </span>
                                                                    <button
                                                                        onClick={() => handleRemoveCategory(category.category_id)}
                                                                        className="text-red-500 hover:text-red-600"
                                                                    >
                                                                        <IoMdClose size={20} />
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </Draggable>
                                                    ))}
                                                {provided.placeholder}
                                            </div>
                                        )}
                                    </Droppable>
                                </DragDropContext>


                                {/* Dropdown for adding categories back */}
                                <div className="mb-4">
                                    <label htmlFor="addCategory" className="block text-sm font-semibold mb-2 text-gray-700">
                                        Add Category
                                    </label>
                                    <select
                                        id="addCategory"
                                        name="addCategory"
                                        value={selectedCategoryId}
                                        onChange={(e) => setSelectedCategoryId(e.target.value)}
                                        className="block w-full py-3 px-4 text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300"
                                    >
                                        <option value="" disabled>
                                            {tempCategories.length === Object.keys(categoryNames).length ? "All categories selected" : "Select a category to add"}
                                        </option>
                                        {Object.keys(categoryNames).map((categoryId) => {
                                            const id = parseInt(categoryId);
                                            if (!tempCategories.some(cat => cat.category_id === id)) {
                                                return (
                                                    <option key={id} value={id}>
                                                        {categoryNames[id]}
                                                    </option>
                                                );
                                            }
                                            return null;
                                        })}
                                    </select>
                                </div>

                                {/* Add Button */}
                                <div className="flex justify-end mb-4">
                                    <button
                                        onClick={() => {
                                            if (selectedCategoryId) {
                                                const categoryId = parseInt(selectedCategoryId);
                                                const categoryToAdd = {
                                                    id: Math.max(...tempCategories.map(c => c.id), 0) + 1,
                                                    visualizer_id: 2,
                                                    category_id: categoryId,
                                                    order: tempCategories.length + 1,
                                                    status: true,
                                                    created_at: new Date().toISOString(),
                                                    updated_at: new Date().toISOString(),
                                                };
                                                setTempCategories([...tempCategories, categoryToAdd]);
                                                setSelectedCategoryId(""); // Reset the selected category
                                            }
                                        }}
                                        className="bg-gradient-to-r from-teal-400 to-teal-500 text-white rounded-lg px-6 py-2 hover:from-teal-500 hover:to-teal-600 transition shadow-md"
                                        disabled={!selectedCategoryId}
                                    >
                                        Add Category
                                    </button>
                                </div>

                                {/* Save Button */}
                                <div className="flex justify-end">
                                    <button
                                        onClick={handleSaveCategories}
                                        className="bg-gradient-to-r from-teal-400 to-teal-500 text-white rounded-lg px-6 py-2 hover:from-teal-500 hover:to-teal-600 transition shadow-md"
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default DetailsAgain;
